import { useState, useEffect } from "react";
import { FaAngleRight, FaAngleLeft } from "react-icons/fa";
import { useParams } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'
import useFetch from "../Components/FetchHook";
import Modal from "./Modal"; // Import the modal component
// import { Helmet } from "react-helmet";
import { HelmetProvider } from 'react-helmet-async';
import { Helmet } from 'react-helmet-async';



// var data = require("../pages/data.json");

const Description = ( {handleAddToCart} ) => {
  const { id } = useParams(); 
  const [isModalOpen, setIsModalOpen] = useState(false); // State to control modal visibility

  const{data, pending, error}=useFetch(`https://campus-closet-server.vercel.app/items/products`)
  
  // Find the item with the specified ID from the data array
  var selectedItemData=""
  if (data) {
    selectedItemData = data.find((item) =>  item.pid === id.split('-')[0]);
}
// if (selectedItemData.is_purchased) {
//   console.log("yoh");
// }

  // Function to open the modal
  const openModal = () => {
    setIsModalOpen(true);
  };

  // Function to close the modal
  const closeModal = () => {
    setIsModalOpen(false);
  };

  const [cartItems, setCartItems] = useState(() => {
    const storedItems = localStorage.getItem('cartItems');
    return storedItems ? JSON.parse(storedItems) : [];
  });
  
  useEffect(() => {
    localStorage.setItem('cartItems', JSON.stringify(cartItems));
  }, [cartItems]);

     // Calculate 30% of the price and the discounted price
  const discountPercentage = 30;
  const originalPrice = Math.round((selectedItemData?.price * 100) / 70);
      //when one adds items to cart
      const handleAddToCartClick = () => {
        handleAddToCart(selectedItemData);
        setCartItems([...cartItems, selectedItemData]); // Add the selected item to the cartItems state
        toast.success("Item added successfully!", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1000,
        });
      };

      
  return (
    <section className="w-full flex flex-col items-center justify-center mb-10" style={{minHeight: "calc(100vh - 120px)" }}>
    
      <div className="w-6/6 sm:w-5/6 md:w-4/6 ml-5 lg:px-5">
        <div className="block md:flex mt-2 md:mt-12 space-x-5 lg:space-x-16">
          {selectedItemData ?(<div className="shadow-2xl h-56 w-80 rounded-md bg-white flex flex-col">
            {selectedItemData && (
              <img
                className="h-full w-full object-contain rounded-md cursor-pointer"
                // src={selectedDataItems[0]?.image.replace("/v", "/q_35/v")}
                src={selectedItemData.image.replace("/v", "/q_35/v")}
                alt={selectedItemData.product_name}
                onClick={openModal} // Open the modal when the image is clicked
              />
            )}
          </div>
          ): pending ? (
            <div>
              <p>Loading...</p>
            </div>
          ):null}
          {selectedItemData && (
            <div className="">
              <p className="text-orange-500 pt-7">{selectedItemData.owner_name.split(" ")[0]} <span className="text-black">is selling:</span></p>
              <h2 className="text-3xl font-bold pt-2">{selectedItemData.product_name}</h2>
              <p className="pb-2 pt-4 ">{selectedItemData.description}</p>
              <div className="flex space-x-5 mt-2">
                <p id="price" className="text-2xl font-bold ">
                  KSh {selectedItemData.price}
                </p>
                <p className="mt-1 rounded-lg bg-slate-200 px-2 h-6 text-orange-500">{discountPercentage}% off</p>
              </div>
              <p className="mt-1 text-gray-500 text-sm line-through">KSh {originalPrice}</p>
              {selectedItemData.is_purchased ? (
            <button disabled className="bg-gray-300 w-60 py-2 md:w-48 rounded-md shadow-xl mt-3 cursor-not-allowed">
              Already Purchased
            </button>
          ) :!cartItems.find(item => item.pid === selectedItemData.pid) ? ( // Render the button only if the item is not added to the cart
                <button
                  onClick={handleAddToCartClick}
                  className="bg-orange-500 w-60 py-2 md:w-48 rounded-md shadow-xl mt-3 shadow-orange-200"
                >
                  Add to cart
                </button>
              ) : (
                <button disabled className="bg-gray-300 w-60 py-2 md:w-48 rounded-md shadow-xl mt-3 cursor-not-allowed">
                  Added to cart
                </button>
              )}
            </div>
          )}
        </div>
      </div>
      <ToastContainer />

      {/* Modal component */}
      {isModalOpen && (
        <Modal closeModal={closeModal}>
          {/* Content inside the modal */}
          {selectedItemData && (
            <img
              className="h-full w-full object-cover rounded-md"
              src={selectedItemData.image.replace("/v", "/q_35/v")}
              // src={selectedDataItems[0]?.image.replace("/v", "/q_35/v")}
              alt={selectedItemData.description}
            />
          )}
        </Modal>
      )}
    </section>
  );
};

export default Description;


// import React from “react”; 
// import MetaTags from “react-meta-tags”;

// const Description = ({ handleAddToCart }) => { // Your existing code here 
//   return ( <section className=“w-full flex flex-col items-center justify-center mb-10” style={{ height: “calc(100vh - 120px)” }}> 
//   <MetaTags> <title>{selectedItemData.product_name}</title> <meta name=“description” content={selectedItemData.description} /> <meta property=“og:title” content={selectedItemData.product_name} /> <meta property=“og:image” content={selectedItemData.image} /> <meta property=“og:url” content={https://campus-closet.vercel.app/desc/${id}} /> <meta property=“og:image:width” content=“1024” /> <meta property=“og:image:height” content=“449” /> <meta property=“og:description” content={selectedItemData.description} /> <meta property=“og:type” content=“website” /> </MetaTags> {/* Your existing code here */} </section> ); };

// export default Description;
